(function () {
	'use strict';
	$(document).ready(function () {

		const swiperClients = new Swiper('.homepage .swiper-clients', {
			slidesPerView: 2,
			loop: true,
			spaceBetween: 15,
			breakpoints: {
				1366: {
					slidesPerView: 5,
				},
				1024: {
					slidesPerView: 4,
				},
				768: {
					slidesPerView: 3,
				}
			}
		});

	});
}(jQuery));
